/** Сколько сообщений запрашиваем при открытии и добавляем при каждой догрузке */
export const SUPPORT_MESSAGES_PAGE_SIZE = 30;

/** Расстояние до верха ленты (px), при котором начинаем догружать историю */
export const LOAD_MORE_SCROLL_THRESHOLD = 40;
